import BlogContentContainer, { ComponentUnderTest } from './BlogContentContainer';

export default BlogContentContainer;
export {
  ComponentUnderTest,
};
